export default function SearchableMultiselectComponent(gettextCatalog) {
  'ngInject';
  return {
    template: require('./searchable-multi-select-dropdown.html'),
    restrict: 'AE',
    scope: {
      displayAttr: '@',
      selectedItems: '=',
      allItems: '=',
      readOnly: '=',
      addItem: '&',
      removeItem: '&',
      selectedItemChanged: '&'
    },
    link: function (scope, element, attrs) {
      element.bind('click', function (e) {
        e.stopPropagation();
      });

      scope.status = {
        isopen: false
      };

      scope.toggleDropdown = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        $scope.status.isopen = !$scope.status.isopen;
      };

      scope.updateSelectedItems = function (obj) {
        var selectedObj;
        for (let i = 0; typeof scope.selectedItems !== 'undefined' && i < scope.selectedItems.length; i++) {
          if (scope.selectedItems[i][scope.displayAttr].toUpperCase() === obj[scope.displayAttr].toUpperCase()) {
            selectedObj = scope.selectedItems[i];
            break;
          }
        }
        if (typeof selectedObj === 'undefined') {
          scope.addItem({
            item: obj
          });
        } else {
          scope.removeItem({
            item: selectedObj
          });
        }
      };

      scope.isItemSelected = function (item) {
        if (typeof scope.selectedItems === 'undefined') return false;

        let tmpItem;
        for (let i = 0; i < scope.selectedItems.length; i++) {
          tmpItem = scope.selectedItems[i];
          if (typeof tmpItem !== 'undefined' &&
            typeof tmpItem[scope.displayAttr] !== 'undefined' &&
            typeof item[scope.displayAttr] !== 'undefined' &&
            tmpItem[scope.displayAttr].toUpperCase() === item[scope.displayAttr].toUpperCase()) {
            return true;
          }
        }

        return false;
      };

      scope.commaDelimitedSelected = function () {
        var list = "";
        angular.forEach(scope.selectedItems, function (item, index) {
          list += item[scope.displayAttr];
          if (index < scope.selectedItems.length - 1) list += ', ';
        });
        return list.length ? list : gettextCatalog.getString("Nothing Selected");
      };
    }
  };
}